module.exports = __webpack_public_path__ + "static/img/role.d4bcddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/mx/role.png
// module id = JhKC
// module chunks = 7